import { render } from "./SearchGenreBar.vue?vue&type=template&id=1e16340a&scoped=true"
import script from "./SearchGenreBar.vue?vue&type=script&lang=js"
export * from "./SearchGenreBar.vue?vue&type=script&lang=js"

import "./SearchGenreBar.vue?vue&type=style&index=0&id=1e16340a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e16340a"

export default script